import React from "react";
import {
  Tag,
  Typography,
  Tooltip,
  Popconfirm,
  Space,
  Button,
  Divider,
} from "antd";
import { ExportOutlined } from "@ant-design/icons";
import AuthChecker from "../../components/authChecker";
import roleAndPermission from "../../constants/permissions";
import { SERVICE_DEFAULT_SLUG } from "../../pages/cms-pages/builder/constant";
import { exceptionSlugs } from "../../constants/exceptionSlug";

const { Text } = Typography;

export const getCMSColumns = ({
  handleToggleStatus,
  handleClearCache,
  handleDeletePage,
  clearingCache,
  activeTab,
  navigate,
}) => [
  {
    title: "Page Title",
    dataIndex: "title",
    key: "title",
    render: (text, record) => {
      const displayTitle =
        record.slug === "authorized-car-radio-repair-near-me"
          ? "Authorized Car Radio Repair Near Me"
          : record.title || record.slug;

      const exceptionGroups = ["header", "footer"];
      const isException =
        exceptionSlugs.includes(record.slug) ||
        exceptionGroups.includes(String(record.group || "").toLowerCase());
      const siteUrl = process.env.REACT_APP_CUSTOMER_SITE_URL || "";
      // If it's a blog, prefix with blog/ (assuming standard routing). Otherwise just use slug.
      const pathPrefix =
        String(record.group).toLowerCase() === "blogs" ? "blog/" : "";
      const fullUrl = `${siteUrl}/${pathPrefix}${record.slug}`;

      return (
        <div>
          <div style={{ fontWeight: 600, fontSize: 14, color: "#1f2937" }}>
            {displayTitle}
            {/* {record.slug === SERVICE_DEFAULT_SLUG && (
              <Tag  color="blue" style={{ marginLeft: 8 }}>
                Default template
              </Tag>
            )} */}
          </div>
          {isException ? (
            <Text type="secondary" style={{ fontSize: 12 }}>
              /{record.slug}
            </Text>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <Text type="secondary" style={{ fontSize: 12 }}>
                /{record.slug}
              </Text>
              <Tooltip
                title={fullUrl}
                color="#dc2626"
                overlayStyle={{ maxWidth: "none" }}
                overlayInnerStyle={{
                  borderRadius: 8,
                  padding: "6px 12px",
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                }}
              >
                <a
                  href={fullUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    fontSize: 14,
                    color: "#dc2626",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  <ExportOutlined />
                </a>
              </Tooltip>
            </div>
          )}
        </div>
      );
    },
  },
  {
    title: "Group / Scope",
    dataIndex: "group",
    key: "group",
    render: (group) => (
      <span style={{ color: "#6b7280", textTransform: "capitalize" }}>
        {group || "Global"}
      </span>
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status, record) => {
      const isPublished = status === "ACTIVE" || status === "Published";
      const isDraft = status === "DRAFT" || status === "Draft";
      const label = isPublished ? "Published" : isDraft ? "Draft" : "Inactive";
      const tagColor = isPublished ? "green" : isDraft ? "orange" : "red";

      return (
        <Popconfirm
          title={`Change status to ${isPublished ? "DRAFT" : "ACTIVE"}?`}
          onConfirm={() => handleToggleStatus(record)}
          okText="Yes"
          cancelText="No"
        >
          <Tag
            color={tagColor}
            className="status-tag"
            style={{ cursor: "pointer" }}
          >
            {label}
          </Tag>
        </Popconfirm>
      );
    },
  },
  {
    title: "Actions",
    key: "actions",
    align: "right",
    render: (_, record) => {
      return (
        <Space size="small">
          <AuthChecker permissions={[roleAndPermission.PageManagement.update]}>
            <Button
              type="text"
              onClick={() => {
                const recordGroup =
                  record.group || (activeTab !== "all" ? activeTab : "page");
                navigate(
                  `/edit-cms/${encodeURIComponent(record.slug)}?group=${recordGroup}`,
                );
              }}
            >
              Edit
            </Button>
          </AuthChecker>
          <Divider type="vertical" />

          <AuthChecker permissions={[roleAndPermission.PageManagement.update]}>
            <Button
              loading={clearingCache === record.id}
              onClick={() => handleClearCache(record)}
              type="text"
            >
              Clear cache
            </Button>
          </AuthChecker>
          <Divider type="vertical" />
          {String(record.group || "").toLowerCase() !== "system" && (
            <Popconfirm
              title="Are you sure you want to delete this CMS page?"
              onConfirm={() => handleDeletePage(record)}
              okText="Yes"
              cancelText="No"
            >
              <Button danger type="text">
                Delete
              </Button>
            </Popconfirm>
          )}
        </Space>
      );
    },
  },
];
